export type { DialogProps } from './Dialog'
export { Dialog } from './Dialog'
